export default "__VITE_ASSET__B5ie2LsG__"